// This function returns a copy of the filters object in the format expected by the api
export function getFilterValues(filters) {
  let filterValues = { ...filters };
  let group_ids = [];
  let location_ids = [];

  for (const [filterName, filterValue] of Object.entries(filterValues)) {
    if (Array.isArray(filterValue) && filterName !== 'domains') {
      filterValues[filterName] = filterValue.map((filter) => filter.value);
    }

    if (filterName === 'domains') {
      filterValue.forEach((item) => {
        if (item.className.includes('filter-group')) {
          group_ids.push(item.value);
        } else if (item.className.includes('filter-location')) {
          location_ids.push(item.value);
        }
      });
      filterValues.group_ids = group_ids;
      filterValues.location_ids = location_ids;
      delete filterValues.domains;
    }

    if (filterName === 'ds_alert_sent') {
      filterValues[filterName] = filterValue === true ? ['Alert'] : [];
    }
    if (filterName === 'ds_appt_set') {
      filterValues[filterName] = filterValue === true ? ['Appointments'] : [];
    }
  }

  return filterValues;
}

export function momentDurationToTime(dur) {
  const hours = Math.floor(dur.asHours());
  const mins = Math.floor(dur.asMinutes()) - hours * 60;
  const sec = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60;

  return (
    (hours > 9 ? hours : '0' + hours) +
    ':' +
    (mins > 9 ? mins : '0' + mins) +
    ':' +
    (sec > 9 ? sec : '0' + sec)
  );
}
